import Helper from './Helper';

class StringReplacer {
  constructor(config = {}) {
    const {
      stringToBeReplaced,
      stringToReplace,
      elementSelectorToSearchFor
    } = config;
    const searchedElems = document.querySelectorAll(elementSelectorToSearchFor);
    const searchArray = Array.prototype.slice.call(searchedElems);

    if(searchArray){
      searchArray.forEach(searchElem => {
        const txt = searchElem.innerText;
        // console.log(txt);
        if(txt.indexOf(stringToBeReplaced) !== -1){
          // console.log('string found');
          searchElem.innerHTML = stringToReplace;
          // console.log('replaced');
        }
      });
    }
  }
}

export default StringReplacer;
